define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.pop;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/pop.js
// module id = 485
// module chunks = 0